const en_US = {
  placeholderText: "Enter",
  closeContentText: "End current conversation?",
  cancelText: "Cancel",
  okText: "OK",
  loadingAnswerQuestions:
    "Answering your previous question. Please wait before submitting.",
  networkAnomalyText: "Network error. Please try again later.",
  errorText: "Server Error",
  messageTooShort: "At least two characters must be entered.",
  messageTooLong: "Cannot exceed 200 characters.",
  messageCannotBeEmpty: "The question cannot be empty",
  systemErrorText: "System error. Please try again later.​",
  fileSizeExceeded: "File size must not exceed {maxSize}MB.",
  fileUploadSuccess: "File uploaded successfully",
  fileUploadFailed: "File upload failed",
  emailErrorText: "Invalid email format.",
  emailEmptyText: "please enter it the email address",
  uploadingText: "Uploading...",
  abnormalDisconnectionText: "Connection lost. Reconnecting now...",
  reconnectToServerText: "Unable to reconnect to server",
  evaluationText: "Your feedback helps us improve!",
  emailLabel: "Email",
  emailPlaceholder: "Enter your email address",
  productLabel: "Product",
  productPlaceholder: "Select a product",
  problemLabel: "Issue Description",
  problemPlaceholder: "Describe your issue in detail",
  submitText: "Submit",
  submitField: "Sorry, submission failed. Please try again later.",
  thankText:
    "Thank you for your cooperation! We will contact you as soon as possible! Please check your email or {link}​ for updates!",
  clickHere: "click here​",
  thankEvaluation: "Thank you for your feedback!",
  wsErrorText: "Unable to connect to manual customer service",
  codeLabel: "Verification Code",
  codePlaceholder: "Please enter the verification code",
  submittedSuccessfully: "Successfully submitted",
  supportContact: "Support Contact",
  stillCancel: "Still Cancel",
  useDiscount: "Use Discount",
  pauseDuration: "Pause Duration",
  uploadAttachment: "Upload Attachment",
};
export default en_US;
